import api from './client';
import type { UsoTelemetria, UsoTelemetriaFiltros } from '../types/telemetria';

export const telemetriaApi = {
  /** Leitura agregada da telemetria de uso (`GET /api/telemetria/uso`, policy `auditoria`).
   *  Não confundir com `utils/telemetria.ts` (o beacon de ESCRITA que o SPA usa
   *  pra reportar o próprio uso) — este client é só leitura, consumido pela aba Uso. */
  uso: async ({ dias, origem, incluirAdmin }: UsoTelemetriaFiltros): Promise<UsoTelemetria> => {
    const params = new URLSearchParams({ dias: String(dias) });
    if (origem) params.set('origem', origem);
    if (incluirAdmin) params.set('incluirAdmin', 'true');
    const resp = await api.get<{ success: boolean; data: UsoTelemetria }>(`/telemetria/uso?${params.toString()}`);
    return resp.data.data;
  },
};
